// import React, { useEffect, useState } from "react";
// import { Download, Trash2 } from "lucide-react";
// import { Popconfirm } from "antd";

// // Dummy toggle (set to false to use actual hooks)
// const USE_DUMMY_DATA = true;

// const ORDERS_PER_PAGE = 5;

// const dummyOrders = [
//   {
//     createdAt: "2025-07-30T10:00:00Z",
//     awbNumber: "33808513595760",
//     shippingStatus: "in_transit",
//     InvoiceAmount: 1499,
//     PaymentType: "Prepaid",
//     ProductDetails: [{ Name: "T-Shirt" }, { Name: "Jeans" }],
//     CustomerName: "Rahul Mehta",
//     BillingAddress: {
//       Contact: "9876543210",
//       City: "Ahmedabad",
//       State: "Gujarat",
//       Pincode: "380015",
//     },
//     courier: "Delhivery",
//     shipcluesOrderId: "SHIP12345",
//   },
//   {
//     createdAt: "2025-07-29T14:30:00Z",
//     awbNumber: null,
//     shippingStatus: "out_for_delivery",
//     InvoiceAmount: 799,
//     PaymentType: "COD",
//     ProductDetails: [{ Name: "Bluetooth Speaker" }],
//     CustomerName: "Sneha Shah",
//     BillingAddress: {
//       Contact: "9876501234",
//       City: "Surat",
//       State: "Gujarat",
//       Pincode: "395007",
//     },
//     courier: "XpressBees",
//     shipcluesOrderId: "SHIP67890",
//   },
// ];

// const Live = ({ status = ["in_transit", "out_for_delivery"] }) => {
//   // Use dummy or real API data
//   const { data, isLoading, isError, refetch } = USE_DUMMY_DATA
//     ? {
//         data: { orders: dummyOrders },
//         isLoading: false,
//         isError: false,
//         refetch: () => {},
//       }
//     : require("../../../../../api/orders/orders").useAllOrders(status);

//   const { mutate: cancelOrder } = USE_DUMMY_DATA
//     ? { mutate: (id) => alert("Cancel order: " + id) }
//     : require("../../../../../api/orders/orders").useCancelOrder();

//   const { mutate: downloadLabel, isLoading: downloading } = USE_DUMMY_DATA
//     ? {
//         mutate: (awb) => alert("Downloading label for AWB: " + awb),
//         isLoading: false,
//       }
//     : require("../../../../../api/orders/orders").useDownloadLabel();

// useEffect(() => {
//   refetch();
// }, [refetch]);

//   const orders = data?.orders || [];

//   const filteredOrders = Array.isArray(status)
//     ? orders.filter((order) => status.includes(order.shippingStatus))
//     : orders;

//   const totalPages = Math.ceil(filteredOrders.length / ORDERS_PER_PAGE);
//   const [currentPage, setCurrentPage] = useState(1);
//   const paginatedOrders = filteredOrders.slice(
//     (currentPage - 1) * ORDERS_PER_PAGE,
//     currentPage * ORDERS_PER_PAGE
//   );

//   if (isLoading) return <p className="text-gray-500 mt-4">Loading...</p>;
//   if (isError)
//     return <p className="text-red-600 mt-4">Error fetching orders</p>;

//   return (
//     <div className="w-full mt-6">
//       <div className="overflow-x-auto">
//         <table className="min-w-[1200px] w-full table-auto border border-gray-200">
//           <thead className="bg-gray-100 text-left text-sm font-semibold text-gray-700">
//             <tr>
//               <th className="p-3">Order Date</th>
//               <th className="p-3">AWB Number/Status</th>
//               <th className="p-3">Payment</th>
//               <th className="p-3">Products</th>
//               <th className="p-3">Customer</th>
//               <th className="p-3">Contact</th>
//               <th className="p-3">Address</th>
//               <th className="p-3">Courier Partner/Tracking</th>
//             </tr>
//           </thead>
//           <tbody className="bg-white text-sm">
//             {paginatedOrders.map((order, index) => (
//               <tr key={index} className="hover:bg-gray-50">
//                 <td className="p-4">
//                   {new Date(order.createdAt).toLocaleDateString()}
//                 </td>
//                 <td className="p-4">
//                   <div className="font-medium text-blue-600">
//                     {order.awbNumber || "N/A"}
//                   </div>
//                   <div
//                     className={`text-xs font-semibold px-2 py-1 rounded inline-block mt-1 ${
//                       order.shippingStatus === "cancelled"
//                         ? "bg-red-100 text-red-600"
//                         : order.shippingStatus === "in_transit"
//                         ? "bg-blue-100 text-blue-600"
//                         : order.shippingStatus === "shipped"
//                         ? "bg-green-100 text-green-600"
//                         : "bg-yellow-100 text-yellow-600"
//                     }`}
//                   >
//                     {order.shippingStatus}
//                   </div>
//                 </td>
//                 <td className="p-4">
//                   <p>₹{order.InvoiceAmount}</p>
//                   <span className="inline-block text-xs bg-green-100 text-green-700 px-2 py-1 rounded mt-1">
//                     {order.PaymentType}
//                   </span>
//                 </td>
//                 <td className="p-4">
//                   {order.ProductDetails?.map((prod, i) => (
//                     <p key={i} className="truncate">
//                       {prod.Name}
//                     </p>
//                   ))}
//                 </td>
//                 <td className="p-4">{order.CustomerName}</td>
//                 <td className="p-4">{order.BillingAddress?.Contact}</td>
//                 <td className="p-4 text-sm">
//                   <p>{order.BillingAddress?.City}</p>
//                   <p>{order.BillingAddress?.State}</p>
//                   <p>{order.BillingAddress?.Pincode}</p>
//                 </td>
//                 <td className="p-4 space-y-2">
//                   <p className="text-sm font-medium text-gray-700">
//                     {order?.courier}
//                   </p>

//                   {order.awbNumber ? (
//                     <a
//                       href={`https://shipclues.com/track-order/${order.awbNumber}`}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition-colors duration-200"
//                     >
//                       Track Order
//                     </a>
//                   ) : (
//                     <span className="inline-block px-3 py-1 bg-gray-100 text-gray-500 text-sm rounded">
//                       AWB Not Available
//                     </span>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="flex justify-between items-center mt-6 text-sm text-gray-700">
//         <p>
//           Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
//         </p>
//         <div className="space-x-2">
//           <button
//             onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//             disabled={currentPage === 1}
//             className={`px-4 py-2 rounded border ${
//               currentPage === 1
//                 ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                 : "bg-white hover:bg-gray-50"
//             }`}
//           >
//             Previous
//           </button>
//           <button
//             onClick={() =>
//               setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//             }
//             disabled={currentPage === totalPages}
//             className={`px-4 py-2 rounded border ${
//               currentPage === totalPages
//                 ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                 : "bg-white hover:bg-gray-50"
//             }`}
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Live;

import React, { useEffect, useState } from "react";
import { Input } from "antd";
import {
  useAllOrders,
  useSearchOrders,
} from "../../../../../api/orders/orders";
import { useLoader } from "../../../../../utils/LoaderContext";

const ORDERS_PER_PAGE = 20;

const Live = ({ status = "live" }) => {
  const { setLoading } = useLoader();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");

  useEffect(() => {
    const delay = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchText]);

  const {
    data: allData = [],
    isLoading: loadingAll,
    isError,
    refetch,
  } = useAllOrders({ currentPage, ORDERS_PER_PAGE, status });

  const { data: searchedData = [], isLoading: loadingSearch } = useSearchOrders(
    debouncedSearchText,
  );

  const isLoading = searchText ? loadingSearch : loadingAll;

  const orders = searchText ? searchedData : allData?.orders || [];

  const filteredOrders = Array.isArray(status)
    ? orders.filter((order) => status.includes(order.shippingStatus))
    : orders;

  useEffect(() => {
    setLoading(true);
    refetch().finally(() => setLoading(false));
  }, [refetch, setLoading]);

  const totalPages = Math.ceil(filteredOrders.length / ORDERS_PER_PAGE);
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * ORDERS_PER_PAGE,
    currentPage * ORDERS_PER_PAGE
  );

  if (isError)
    return <p className="text-red-600 mt-4">Error fetching orders</p>;

  return (
    <div className="w-full mt-6">
      {/* Search */}
      <div className="mb-4 flex justify-between items-center">
        <Input
          className="w-80"
          placeholder="Search by AWB, Order Number or Name"
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <div className="overflow-x-auto hide-scrollbar">
        <table className="min-w-[1200px] w-full table-auto border border-gray-200">
          <thead className="bg-gray-100 text-left text-sm font-semibold text-gray-700">
            <tr>
              <th className="p-3">Order Date</th>
              <th className="p-3">AWB Number / Status</th>
              <th className="p-3">Payment</th>
              <th className="p-3">Products</th>
              <th className="p-3">Customer / Contact</th>
              <th className="p-3">Address</th>
              <th className="p-3">Courier / Tracking</th>
            </tr>
          </thead>
          <tbody className="bg-white text-sm">
            {isLoading ? (
              <tr>
                <td colSpan={7}>
                  <div className="flex justify-center items-center py-10 text-gray-500 space-x-2">
                    <span className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></span>
                    <span>Loading orders...</span>
                  </div>
                </td>
              </tr>
            ) : paginatedOrders.length > 0 ? (
              paginatedOrders.map((order, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="p-4">
                    {new Date(order.createdAt).toLocaleDateString()}
                  </td>
                  <td className="p-4">
                    <div className="font-medium text-blue-600">
                      {order.awbNumber || "N/A"}
                    </div>
                    <div
                      className={`text-xs font-semibold px-2 py-1 rounded inline-block mt-1 ${
                        order.shippingStatus === "cancelled"
                          ? "bg-red-100 text-red-600"
                          : order.shippingStatus === "in_transit"
                          ? "bg-blue-100 text-blue-600"
                          : order.shippingStatus === "shipped"
                          ? "bg-green-100 text-green-600"
                          : order.shippingStatus === "out_for_delivery"
                          ? "bg-yellow-100 text-yellow-600"
                          : "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {order.shippingStatus}
                    </div>
                  </td>
                  <td className="p-4">
                    ₹{order.total_amount}
                    <div className="text-xs mt-1 bg-green-100 text-green-700 inline-block px-2 py-1 rounded">
                      {order.PaymentType}
                    </div>
                  </td>
                  <td className="p-4">
                    {order.ProductDetails?.map((prod, i) => (
                      <p key={i} className="truncate">
                        {prod.name}
                      </p>
                    ))}
                  </td>
                  <td className="p-4">
                    <p>{order.CustomerName}</p>
                    <p>{order.BillingAddress?.phone}</p>
                  </td>
                  <td className="p-4 text-sm">
                    <p>{order.BillingAddress?.city}</p>
                    <p>{order.BillingAddress?.state}</p>
                    <p>{order.BillingAddress?.pincode}</p>
                  </td>
                  <td className="p-4">
                    <p>{order?.courier}</p>
                    {order.awbNumber ? (
                      <a
                        href={`https://shipclues.com/track-order/${order.awbNumber}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition-colors duration-200 mt-1"
                      >
                        Track Order
                      </a>
                    ) : (
                      <span className="inline-block px-3 py-1 bg-gray-100 text-gray-500 text-sm rounded mt-1">
                        AWB Not Available
                      </span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center py-6 text-gray-400">
                  No live orders found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-between items-center mt-6 text-sm text-gray-700">
        <p>
          Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
        </p>
        <div className="space-x-2">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded border ${
              currentPage === 1
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-white hover:bg-gray-50"
            }`}
          >
            Previous
          </button>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className={`px-4 py-2 rounded border ${
              currentPage === totalPages
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-white hover:bg-gray-50"
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Live;
